import { render } from "./splashIcons.vue?vue&type=template&id=d065b500&scoped=true"
import script from "./splashIcons.vue?vue&type=script&lang=js"
export * from "./splashIcons.vue?vue&type=script&lang=js"

import "./splashIcons.vue?vue&type=style&index=0&id=d065b500&scoped=true&lang=css"

import exportComponent from "/home/sergiugata/taptasty/-taptasty-order/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d065b500"]])

export default __exports__